import { Route, Routes } from "react-router-dom";

import { Layout } from "@/components/Layout";
import { RequireAuth } from "@/auth/RequireAuth";
import { Catalog } from "@/pages/Catalog";
import { ProductDetail } from "@/pages/ProductDetail";
import { Cart } from "@/pages/Cart";
import { Checkout } from "@/pages/Checkout";
import { CheckoutSuccess } from "@/pages/CheckoutSuccess";
import { CheckoutCancel } from "@/pages/CheckoutCancel";
import { Orders } from "@/pages/Orders";
import { Entitlements } from "@/pages/Entitlements";
import { Login } from "@/pages/Login";
import { Register } from "@/pages/Register";

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Catalog />} />
        <Route path="/p/:slug" element={<ProductDetail />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/checkout/success" element={<CheckoutSuccess />} />
        <Route path="/checkout/cancel" element={<CheckoutCancel />} />
        <Route
          path="/checkout"
          element={
            <RequireAuth>
              <Checkout />
            </RequireAuth>
          }
        />
        <Route
          path="/orders"
          element={
            <RequireAuth>
              <Orders />
            </RequireAuth>
          }
        />
        <Route
          path="/entitlements"
          element={
            <RequireAuth>
              <Entitlements />
            </RequireAuth>
          }
        />
        <Route path="*" element={<Catalog />} />
      </Route>
    </Routes>
  );
}
